import { onMounted, ref } from 'vue';
import { useResizeObserver } from '@vueuse/core';

/**
 * A composable for imageMap logic
 * @param {import('vue').Ref<HTMLElement | null>} imageRef - A ref of img element
 */
export default function useImageMap(imageRef) {
  const currentWidth = ref(null);

  /**
   * Recalculate coordinates based on current browser width
   *
   * @param {string} coordinates - coordinates separated by comma
   * @param {boolean} imageMapWidth - ImageMap width
   * @returns {string} Updated coordinates
   */
  function getCoords(coordinates, imageMapWidth) {
    if (currentWidth.value && currentWidth.value !== imageMapWidth) {
      const imageWidth = currentWidth.value / imageMapWidth;
      const coords = coordinates.split(',');
      const newCoords = coords.map((item) => Math.round(item * imageWidth));
      return newCoords.join(',');
    }
    return coordinates;
  }

  onMounted(() => {
    useResizeObserver(imageRef, (entries) => {
      currentWidth.value = entries[0].contentRect.width;
    });
  });

  return {
    getCoords,
    currentWidth,
  };
}
